import type { BehaviorEvent } from '../../behaviors/index.js'

function formatDateTime(iso: string): string {
  const date = new Date(iso)
  return Number.isNaN(date.getTime()) ? iso : date.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })
}

/** Reported occurrences of the client's own behaviors for one worker, most recent first. `labels` turns a key into its name where known. */
export function BehaviorEventLog({ events, labels }: { events: BehaviorEvent[]; labels?: ReadonlyMap<string, string> }) {
  if (events.length === 0) {
    return <div className="text-[11px] text-ink-mid">No custom behavior events reported yet.</div>
  }

  return (
    <ul className="bg-white border border-marine/15 divide-y divide-marine/10">
      {events.map((event) => (
        <li key={event.eventId} className="px-3 py-2">
          <div className="text-[11px] font-bold text-ink">
            {labels?.get(event.behaviorKey) ?? event.behaviorKey}{' '}
            {labels?.has(event.behaviorKey) && <span className="font-mono font-normal text-[10px] text-ink-mid">{event.behaviorKey}</span>}
          </div>
          <div className="text-[10.5px] text-ink-mid">
            {formatDateTime(event.occurredAt)}
            {event.shiftDate && ` · shift ${event.shiftDate}`}
            {event.note && ` · ${event.note}`}
          </div>
        </li>
      ))}
    </ul>
  )
}
